import {GIF, JPG, PDF, PNG, DOC, DOCX, MAX_FILE_SIZE} from 'constants/file/fileTypes';

export type ValidFileType =
    | typeof JPG
    | typeof PNG
    | typeof PDF
    | typeof GIF
    | typeof DOC
    | typeof DOCX;

/**
 * Check file size
 * @param {File} file - File for check
 * @param {number} [maxFileSize=MAX_FILE_SIZE] - Max file size
 * @returns {boolean} Return true if file has no oversize
 */
export const checkFileSize = (file?: File, maxFileSize: number = MAX_FILE_SIZE): boolean =>
    Boolean(file && file.size <= maxFileSize);

/**
 * Check file type
 * @param {File} file - File for check
 * @param {Array<ValidFileType>} [fileTypes=[GIF, JPG, PDF, PNG, DOC]] - Valid file types
 * @returns {boolean} Return true if file has valid type
 */
export const checkFileType = (
    file?: File,
    fileTypes: Array<ValidFileType> = [GIF, JPG, PDF, PNG, DOC],
): boolean => Boolean(file && fileTypes.some((type: ValidFileType): boolean => type === file.type));
